import { Record } from 'immutable';

import PURCHASE_METHODS_VALUES from 'commons-vehicle/PurchaseMethods/constants/purchaseMethodsValues.js';

import BaseVehicle from './BaseVehicle.js';
import EnhancedPricing from './EnhancedPricing';
import Price from './Price';

const CatalogModelSummaryRecord = Record({
    ...BaseVehicle,
    category: 'car',
    country: '',
    price: new Price(),
    enhancedPricing: new EnhancedPricing(),
    disclaimer: '',
    lowEndTrim: {
        modelTrim: {
            id: 0,
            slug: '',
            name: '',
        },
        fuelType: {
            slug: '',
            name: '',
        },
        consumption: {
            city: {
                consumption: 0,
                uype: '',
            },
            highway: {
                consumption: 0,
                uype: '',
            },
            combined: {
                consumption: 0,
                uype: '',
            },
            rechargeTime: 0,
        },
    },
    comingSoon: false,
});

class CatalogModelSummary extends CatalogModelSummaryRecord {
    getFinancingByPurchaseMethod(purchaseMethod) {
        switch (purchaseMethod) {
            case PURCHASE_METHODS_VALUES.LEASE:
                return this.enhancedPricing.lease;
            case PURCHASE_METHODS_VALUES.FINANCE:
                return this.enhancedPricing.finance;
            default:
                return this.getTermWithLowestPayment();
        }
    }

    getPurchaseMethodToDisplay(purchaseMethod) {
        if (purchaseMethod === PURCHASE_METHODS_VALUES.LEASE || purchaseMethod === PURCHASE_METHODS_VALUES.FINANCE) {
            return purchaseMethod;
        }

        return this.getPurchaseMethodWithLowestPayment();
    }

    getPurchaseMethodWithLowestPayment() {
        const { lease, finance } = this.enhancedPricing;
        const isLeaseValid = lease.term && lease.payment > 0;
        const isFinanceValid = finance.term && finance.payment > 0;
        const isLeaseSmaller = lease.payment < finance.payment;
        if (isLeaseValid && (isLeaseSmaller || !isFinanceValid)) {
            return PURCHASE_METHODS_VALUES.LEASE;
        }
        return PURCHASE_METHODS_VALUES.FINANCE;
    }

    getTermWithLowestPayment() {
        const purchaseMethod = this.getPurchaseMethodWithLowestPayment();
        if (purchaseMethod === PURCHASE_METHODS_VALUES.LEASE) {
            return this.enhancedPricing.lease;
        }
        return this.enhancedPricing.finance;
    }
}

export default CatalogModelSummary;



// WEBPACK FOOTER //
// ./src/models/CatalogModelSummary.js